/* @ngInject */
const local = (
  storageHandler,
  valueHandler
) => {
  const self = {}

  self.saveCurrentId = (_id) => {
    if (valueHandler.isId(_id)) {
      storageHandler.save('currentOwnerId', _id)
    } else if (valueHandler.isId(_id.id)) {
      storageHandler.save('currentOwnerId', _id.id)
    }
  }

  self.getCurrentId = () => {
    return storageHandler.get('currentOwnerId')
  }

  return self
}

export default local



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/owner/services/local.service.js